<template>
  <div>
    <div v-if="isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div
      v-if="isAuthenticationGranted == false"
      style="justify-content: start"
    >
        <gov-button :wcag-label="$t('user.login')" variant="primary" type="solid" size="m" hoverable class="gov-button-login" @gov-click="loginClickHandler">
          <span class="material-icons"> login </span>
          {{ $t("user.login") }}
        </gov-button>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "CartControl",
  data() {
    return {
      isAuthenticationGranted: null,
    };
  },
  mounted() {
    this.$backend.getAuthenticationStatus(reponse => {
      this.isAuthenticationGranted = reponse.data.authenticationGranted;
    });
  },
    methods: {
        loginClickHandler() {
            console.log("loginClickHandler");
            this.$backend.isTestovaciSLoginem(response => this.zpracujTestovaci(response));
        },
        zpracujTestovaci(response) {
            if (response != null && response.data == true)
                router.push("/" + this.$customerUuid + "/testlogin");
            else
                this.$backend.getMaintenanceStatus(response => this.zpracujOdpovedUdrzby(response) );
        },
        zpracujOdpovedUdrzby(response) {
            if (response.data == true)
                alert("Probíhá údržba - zkuste to prosím později.");
            else
                router.push("/" + this.$customerUuid + "/login");
        },
    },
};
</script>
